<div class="">
  <div class="modal-content">
    <div class="modal-body">
      <button
        (click)="onCancel.emit(true)"
        type="button"
        class="close close-outline"
        data-bs-dismiss="modal"
      >
        <img src="/assets/images/close-button.svg" alt="close icon" />
      </button>

      <div class="pricing-modal-content" style="padding: 15px">
        <h2 class="heading2">Pricing Details<span>*</span></h2>
        <h3 class="heading3">
          $199&nbsp;<span>&nbsp;1 year annual subscription</span>
        </h3>
        <h3 class="heading3">
          $299&nbsp;<span>&nbsp;3 year subscription ($298 savings)</span>
        </h3>
        <div class="mem d-flex justify-content-between">
          <div class="membership">
            <h4 class="heading4">Membership Includes</h4>
            <ul>
              <li>8 total members</li>
              <li>250GB storage</li>
              <li>Video Concierge Support (8am-5pm)</li>
              <li>Chat/Email And Phone Support</li>
            </ul>
          </div>

          <div class="guarentee">
            <p>
              30-day satisfaction guarantee

              <br />
              If you are not completely satisfied
              <br />
              with Family Central within 30 days,
              <br />
              we will refund your purchase to your
              <br />
              original payment method. We are here to help,
              <br />
              please call us at 1-888-780-3264
              <br />
              or send us an email
              <a
                style="color: #000000; text-decoration: underline"
                href="mailto:hello&#64;familycentral.com"
                >Hello&#64;familycentral.com</a
              >
            </p>
          </div>
        </div>

        <div class="membership add-ons">
          <h4 class="heading4">Add ons</h4>
          <ul>
            <li>
              <span
                class="text-bold"
                style="font-weight: 600; text-decoration: underline"
                >1 Year Plan</span
              >
            </li>
            <li><span>$99</span>&nbsp; for additional 8 members</li>
            <li><span>$99</span>&nbsp; for additional 250GB storage</li>
            <li>
              <span
                class="text-bold"
                style="font-weight: 600; text-decoration: underline"
                >3 Year Plan</span
              >
            </li>
            <li><span>$150</span>&nbsp; for additional 8 members</li>
            <li><span>$150</span>&nbsp; for additional 250GB storage</li>
          </ul>
        </div>

        <div class="pricing-cta">
          <div class="cta-wrapper">
            <a disableDuringAjax (click)="auth.login()" class="primary_btn"
              >Subscribe now</a
            >
            <a
              (click)="onCancel.emit(true)"
              class="border_btn"
              routerLink="/questionnaires"
              >Start 14-day free trial</a
            >
          </div>
          <p>No Credit Card Required</p>
          <p>
            <a class="price_singup" routerLink="/questionnaires"
              >*Sign up now or start your free 14-day trial</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
